import { render, staticRenderFns } from "./SectionBlockItemRow.vue?vue&type=template&id=93335164&"
import script from "./SectionBlockItemRow.vue?vue&type=script&lang=js&"
export * from "./SectionBlockItemRow.vue?vue&type=script&lang=js&"
import style0 from "./SectionBlockItemRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports